<template>
    <div class="SignaturePad">
        <b-modal v-if="InModal" ref="create-signature-modal" size="lg" :title="ModalTitle" hide-footer>
            <b-container fluid>
                <div style="max-width:1090px;">
                    <VueSignaturePad width="100%"
                                     height="110px"
                                     ref="signaturePad"
                                     :options="options"
                                     class="signature-box" />
                </div>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="HideModal()">
                            Cancel
                        </b-button>
                        <b-button size="md" variant="info" @click="clear">
                            Clear
                        </b-button>
                        <b-button size="md" variant="primary" @click="Save()">
                            Save
                        </b-button>
                    </div>
                </b-row>
            </b-container>
        </b-modal>
        <div v-else>
            <div style="max-width:1090px;">
                <VueSignaturePad width="100%"
                                 height="110px"
                                 ref="signaturePad"
                                 :options="options"
                                 class="signature-box" />
            </div>
            <b-row class="modal-btn-row">
                <div class="modal-btn-row-div">
                    <b-button size="md" variant="secondary" @click="clear">
                        Clear
                    </b-button>
                    <b-button size="md" variant="primary" @click="Save()">
                        Save
                    </b-button>
                </div>
            </b-row>
        </div>
        
    </div>
</template>
<script>
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        props: ["EndPoint","AdditionalPayload","InModal","ModalTitle"],
        data: function () {
            return {
                options: {
                    penColor: "#000000",
                     onBegin:() => { this.$refs.signaturePad.resizeCanvas() }
                }
            };
        },
        methods: {  
            clear() {
                this.$refs.signaturePad.clearSignature();
            },
            ShowModal() {
                this.$refs["create-signature-modal"].show();
            },
            HideModal() {
                this.$refs["create-signature-modal"].hide();
            },
            Save() {
                let vm = this;
                //Get signature pad data
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                //Get everything after a ',' in the data which would be the png code we need
                var fields = data.split(',');
                var ManuallySignedData = fields[1];
                let formData = new FormData();
                //append signature code to form data
                formData.append("ManuallySignedData", ManuallySignedData);
                let additionalPayloadKeys = Object.keys(this.AdditionalPayload);
                additionalPayloadKeys.forEach(function (key) {
                    formData.append(key, vm.AdditionalPayload[key]);
                });
                this.$MasterAPI.ExecuteRequest("POST", this.EndPoint, formData, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.$emit("success");
                if (this.InModal) {
                    this.HideModal();
                } else {
                    this.clear();
                }
            }
        },
    };
</script>

<style scoped>
      .signature-box {
          border: double 3px transparent;
          border-radius: 5px;
          background-image: linear-gradient(white, white),
            radial-gradient(circle at top left, #4bc5e8, #9f6274);
          background-origin: border-box;
          background-clip: content-box, border-box;
      }
</style>